import React from "react";
import { useHistory } from "react-router-dom";
import { Button, useTitle } from "modules/common";
import { AppRoutes } from "routing";

export const PrivacyPolicy: React.FC = () => {
  useTitle("Izjava o politici privatnosti - eSavjetnik");
  const history = useHistory();

  return (
    <div className="privacy-policy-page">
      <h1 className="mt-40 mr-40 ml-40">Izjava o politici privatnosti</h1>
      <div className="mt-40 mr-40 mb-40 ml-40">
        <p>5. ZAŠTITA OSOBNIH PODATAKA I PRIVATNOSTI PRILIKOM KORIŠTENJA WEB APLIKACIJE e-SAVJETNIK</p>
        <ul>
          <li>
            <strong>Opće odredbe</strong>
            <p>Korištenjem usluga aplikacije e-Savjetnik povjeravate nam svoje osobne podatke. Ovim uvjetima Ministarstvo opisuje način postupanja sa osobnim podacima koji se Korisnicima daju na uvid i koji se od njega prikupljaju.
            Ministarstvo pridaje osobitu pozornost zaštiti osobnih podataka i privatnosti svojih korisnika u skladu s važećim zakonskim i podzakonskim hrvatskim i europskim propisima i najboljom europskom praksom. Zaštita privatnosti korisnika aplikacije e-Savjetnik sastavni je dio naših usluga te važan čimbenik korisničkog iskustva.
            Za potrebe korištenja aplikacije e-Savjetnik, Ministarstvo prikuplja i obrađuje one osobne podatke Korisnika koji su primjereni i nužni za postizanje određene svrhe te u skladu sa svrhom u koju su prikupljeni. Ministarstvo će osobne podatke korisnika čuvati u tajnosti te ih neće distribuirati, objavljivati, davati trećim stranama na korištenje niti ih na bilo koji drugi način učiniti dostupnima bilo kojoj trećoj fizičkoj ili pravnoj osobi bez prethodne suglasnosti Korisnika.</p>
          </li>
          <li>
            <strong>Zaštita podataka</strong>
            <p>Ministarstvo poštuje privatnost svojih Korisnika pa tako i Korisnika aplikacije e-Savjetnik te sa njihovim osobnim podacima postupa odgovorno i pažljivo poduzimajući sve potrebne tehničke, organizacijske i sigurnosne mjere u cilju zaštite istih od gubitka, izmjena, ili neovlaštenog pristupa.
            Korisnikove osobne identifikacijske informacije čuvaju se na serveru, a pristup osobnim podacima je dozvoljen samo ovlaštenim službenicima Ministarstva.</p>
          </li>
          <li>
            <strong>Prikupljanje podataka</strong>
            <p>Ministarstvo prati statističku posjećenost i način korištenja aplikacije e-Savjetnik radi prikupljanja podataka o uspješnosti usluga danih na korištenje Korisnicima.</p>
          </li>
          <li>
            <strong>Povjerljivost podataka trećih osoba</strong>
            <p>Ovi Uvjeti odnose se samo na uporabu i korištenje aplikacije e-Savjetnik te u odnosu na podatke koje Ministarstvo prikuplja od Korisnika u svrhu omogućavanja korištenja navedenih servisa. Druge internetske stranice ili aplikacije kojima se može pristupiti putem aplikacije e-Savjetnik imaju svoje vlastite izjave o povjerljivosti i prikupljanju podataka te načine njihovog korištenja i objavljivanja na njima. Ako Korisnika prebaci na bilo koju takvu stranicu, preporučamo Korisniku da pregleda izjavu o povjerljivosti podataka te stranice. Ministarstvo nije odgovorno za načine i uvjete rada trećih strana s kojima nije u ugovornom odnosu.</p>
          </li>
        </ul>
      </div>
      <div className="mt-40 mr-40 ml-40 mb-48">
        <Button
          type="button"
          size="small"
          variant="warning"
          onClick={() => history.push(AppRoutes.Home)}
          className="mb-24"
        >
          <span>Natrag</span>
        </Button>
      </div>
    </div>
  );
};
